<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      :element-loading-text="$t('Please wait')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"
            >{{ $t('Overseas buyer rating') }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $t('Your rating') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="leavel_container flex-rowl">
        <div class="pic_box">
          <el-image
            style="width: 200px; height: 300px"
            :src="detail.img"
            fit="cover"
            :preview-src-list="detail.bannerList"
          >
            <div slot="error" class="image-slot flex-rowc">
              <i class="iconfont icon-zanwutupian1"></i>
            </div>
          </el-image>
        </div>
        <div class="intro_box">
          <div class="block tit">
            <!-- ellipsis-multiline -->
            <p class="small">
              {{ detail.commodityname_e }}
              <span
                class="copy_box"
                :data-clipboard-text="detail.commodityname_e"
                @click="handleCopyBtn"
                v-if="detail.commodityname_e"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
          </div>
          <div class="block">
            <p>
              {{ detail.multilingualName }}
              <span
                class="copy_box"
                :data-clipboard-text="detail.multilingualName"
                @click="handleCopyBtn"
                v-if="detail.multilingualName"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
          </div>
          <div class="block">
            <p class="small">
              {{ $t('Company Name') }}:
              {{ detail.qyname ? detail.qyname : detail.qy_accountid }}
            </p>
            <p class="small">SKU ID : {{ detail.sku }}</p>
          </div>
          <div class="block leavel_num">{{ $t('Your rating') }}:  {{params.score}} / 5</div>
          <div class="leavel_group flex-rowl">
            <el-rate v-model="params.score" :colors="colors"></el-rate>
            <!-- <span class="iconfont icon-pingfen" v-for="(item, index) in 5" :key="index"></span> -->
          </div>
          <div class="btn flex-rowc" @click="handleSubmit">{{ $t('Submit') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  encryptstringview,
  getCommidityDetail,
  addShopScore,
} from "../../api/api";
import Clipboard from "clipboard";
import { mapState } from "vuex";
export default {
  name: "cManageLeavel",
  data() {
    return {
      value1: 3,
      colors: ["#f62560", "#f62560", "#f62560"],
      loading: false,

      detail: "",

      params: {
        cmid: "",
        username: "",
        openid: "",
        truename: "",
        usertype: "海外用户",
        countryid: "",
        score: null,
      },
    };
  },
  computed: {
    ...mapState(["COUNTRY"]),
  },
  created() {
    let { routerList, OPENID, USERINFO, COUNTRY } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
    this.params.username = USERINFO.username;
    this.params.openid = USERINFO.openid;
    this.params.truename = USERINFO.truename;
    this.params.countryid = COUNTRY.countryid;
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取商品详情
    getDetail() {
      this.loading = true;
      let params = {
        id: this.params.cmid,
        fav_openid: this.params.openid,
      };
      getCommidityDetail(params).then((res) => {
        if (params.countryid == 1) {
          res.multilingualName = res.commodityname;
        } else if (params.countryid == 8) {
          // 英文
          res.multilingualName = res.commodityname_e ? res.commodityname_e : res.commodityname;
        } else if (params.countryid == 2) {
          // 俄语
          res.multilingualName = res.commodityname_m ? res.commodityname_m : res.commodityname_e ? res.commodityname_e : res.commodityname;
        } else if (params.countryid == 4) {
          // 越语
          res.multilingualName = res.commodityname_y ? res.commodityname_y : res.commodityname_e ? res.commodityname_e : res.commodityname;
        }

        this.detail = res;
        this.params.score = res.ams_shop_commodity_score
          ? res.ams_shop_commodity_score.score
          : null;
        this.loading = false;
      });
    },

    handleSubmit() {
      let { params } = this;
      this.loading = true;
      addShopScore(params).then((res) => {
        console.log(res);
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(this.$t('Server Error'));
        }
      });
      // if (multiPriceDetail.id) {
      //   editShopMultiPrice(params).then((res) => {
      //     let data = res;
      //     if (data.result) {
      //       this.loading = false;
      //       this.$message.success(
      //         res.message == "修改成功" ? "修改成功" : res.message
      //       );
      //       // setTimeout(() => {
      //       //   this.loading = false;
      //       //   this.$router.back();
      //       // }, 500);
      //     } else {
      //       this.loading = false;
      //       this.$message.error(
      //         data.message || "服务器报错，请稍候～"
      //       );
      //     }
      //   });
      // } else {
      //   addShopMultiPrice(params).then((res) => {
      //     let data = res;
      //     if (data.result) {
      //       this.$message.success(
      //         res.message == "提交成功" ? "Gửi thành công" : res.message
      //       );
      //       setTimeout(() => {
      //         this.loading = false;
      //         this.$router.back();
      //       }, 500);
      //     } else {
      //       this.loading = false;
      //       this.$message.error(
      //         data.message || "服务器报错，请稍候～"
      //       );
      //     }
      //   });
      // }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t('Copy successful'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .leavel_container {
    margin-top: 35px;
    align-items: flex-start;
  }
  .intro_box {
    margin-left: 24px;
    .tit {
      margin-bottom: 10px;
    }
    .leavel_num {
      margin-top: 15px;
    }
    p {
      font-size: 16px;
      color: #333333;
      &.small {
        font-size: 14px;
        line-height: 15px;
        margin-bottom: 5px;
      }
    }
    .leavel_group {
      color: #d2d2d2;
      margin: 15px 0 35px;
      .iconfont {
        font-size: 20px;
        margin-right: 10px;
        cursor: pointer;
        &.active {
          color: #f62560;
        }
      }
      /deep/.el-rate__icon {
        font-size: 28px;
      }
    }
    .btn {
      display: inline-block;
      cursor: pointer;
      // width: 120px;
      width: auto;
      padding: 0 30px;
      height: 40px;
      line-height: 40px;
      border-radius: 45px;
      background: #f62560;
      font-size: 16px;
      color: #fff;
    }
  }
}
</style>